module.exports = __webpack_public_path__ + "static/media/fire_boots.c33e38e0.png";